// mega-menu-align.js  (assets)
// Desktop mega-menu: makes the image row (Diaries & Journals, Pens…)
// start at exactly the same x position as the first tab (Kawaii Stationery),
// like the Figma "Navbar" frame. Runs after the theme's own menu script,
// so its inline padding wins.

(() => {
  const DESKTOP = window.matchMedia("(min-width: 992px)");
  let raf = 0;

  function align() {
    if (!DESKTOP.matches) return;

    document
      .querySelectorAll(".header__sub_menu.header__sub--has-children-parent")
      .forEach((tabBar) => {
        const firstTab = tabBar.querySelector(
          ":scope > .header__sub_menu_li > .header__sub_menu_item"
        );
        if (!firstTab) return;

        tabBar
          .querySelectorAll(".header__sub--children__menu--grid")
          .forEach((panel) => {
            const grid = panel.querySelector(".header__sub--grid");
            if (!grid) return;

            const x = Math.max(
              0,
              Math.round(
                firstTab.getBoundingClientRect().left -
                  panel.getBoundingClientRect().left
              )
            );

            grid.style.setProperty("padding-left", x + "px", "important");
            grid.style.setProperty("padding-right", x + "px", "important");
            grid.style.setProperty("scroll-padding-left", x + "px", "important");
          });
      });
  }

  function schedule() {
    cancelAnimationFrame(raf);
    // two frames: let the theme's menu-full-width.js position the panel first
    raf = requestAnimationFrame(() => requestAnimationFrame(align));
  }

  document.addEventListener("mouseover", (e) => {
    if (e.target.closest(".header__menu_li")) schedule();
  });
  document.addEventListener("focusin", (e) => {
    if (e.target.closest(".header__menu_li")) schedule();
  });
  window.addEventListener("resize", schedule);
  window.addEventListener("load", schedule);
  if (document.readyState !== "loading") schedule();
  else document.addEventListener("DOMContentLoaded", schedule);
})();
